export default __webpack_public_path__ + "static/center-pt-749bc981f74f32bff2f2ed94ea830cac.webp";